/**
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
 * To add new icons to the system, or to update existing icons, run `clyde mana assets sync -t icons`.
 */

import * as React from 'react';
import tokens from '@discordapp/tokens/web';

import addDefaultIconProps from '../addDefaultIconProps';
import {getIconSize} from '../getIconSize';

import type {SingleColorIconProps} from '../IconTypes';

/**
 * ![GifIcon](data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAABZklEQVR4nN2VPUsDQRCGTxERRFux1cZOFOyUEzEQ9OZjA3czZ5QUiv4DLSxSGguxtxD/gBgbW0F7f4UftRY2FpG9i0HNJUc+BJOFt9jb2X1u3p1lHKdvhu/7w8hyDCTPyFppR8DyhKwle1YdwC60ezDWq1QH6OTP8bdIX5IyqHRTTp8DSO4RFb1cOANGV5D0MqoS0nfEYBVYz+2cKFyz8x9KAwDrreu6Q8wyTRTueSZYiIqA9Q5Y3+JYObSxbqEwsp7bmEIjfk1pACJZBtAJZHmtfvuoZZAAAJbd1ixCHAPWQtWqCyA5sELSm8QMTDD7FQMsD6mATGZz1CPZqnq8Yy2I34nuJwGy2fy4jYmsIi2nAjwOF43JT363qFgsDjYCtGwRsFw7jjNgLznajDrXLIPW7yCSXBHJkmeCeSA9AZJtIDlLLFOW03/40LgXARA3i24BHv+04QDpUYOWqaVOMoFmLbNnxycTN7/fab6kLwAAAABJRU5ErkJggg==)
 */
export const GifIcon = ({
  size = 'md',
  width,
  height,
  color = tokens.colors.INTERACTIVE_NORMAL,
  colorClass = '',
  ...props
}: SingleColorIconProps) => {
  const iconSize = getIconSize(size);
  const iconWidth = iconSize?.width ?? width;
  const iconHeight = iconSize?.height ?? height;
  return (
    <svg
      {...addDefaultIconProps(props)}
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      fill="none"
      viewBox="0 0 24 24">
      <path
        fill={typeof color === 'string' ? color : color.css}
        fillRule="evenodd"
        d="M5 2a3 3 0 0 0-3 3v14a3 3 0 0 0 3 3h14a3 3 0 0 0 3-3V5a3 3 0 0 0-3-3H5Zm2.18 13.87a2.9 2.9 0 0 1-1.66-.49 3.18 3.18 0 0 1-1.12-1.35A4.88 4.88 0 0 1 4 12c0-.75.14-1.42.42-2 .29-.59.7-1.04 1.24-1.37a3.7 3.7 0 0 1 1.95-.5c.64 0 1.21.14 1.72.4.5.28.89.67 1.15 1.16l-1.22.88a1.76 1.76 0 0 0-1.64-1.02c-.66 0-1.17.22-1.52.65a2.74 2.74 0 0 0-.53 1.8c0 .78.18 1.39.53 1.81.35.42.86.64 1.52.64.3 0 .57-.06.81-.16.25-.12.45-.27.58-.47v-.93H7.3v-1.4h3.24v4.23H9.27l-.2-.71c-.43.57-1.06.86-1.89.86Zm6.34-.15h-1.57V8.28h1.57v7.44Zm1.51 0h1.57v-2.83h2.76v-1.42H16.6V9.7H20V8.28h-4.97v7.44Z"
        clipRule="evenodd"
        className={colorClass}
      />
    </svg>
  );
};
